<div class="modal-header">
  <h5 class="modal-title">{{ 'membershipPurchase.title' | translate }}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  <div class="discount-info mb-4">
    <p class="text-muted mb-2">
      {{ 'membershipPurchase.description' | translate:{ itemName: itemName } }}
    </p>
    <div class="current-price">
      <span class="label">{{ 'membershipPurchase.currentPrice' | translate }}:</span>
      <span class="price">{{ basePrice }} {{ currency }}</span>
    </div>
  </div>

  @if (purchasablePlans.length === 0) {
    <div class="alert alert-info">
      {{ 'membershipPurchase.noPlansAvailable' | translate }}
    </div>
  } @else {
    <h6 class="mb-3">{{ 'membershipPurchase.choosePlan' | translate }}:</h6>

    <div class="plan-list">
      @for (planOption of purchasablePlans; track planOption.plan?.plan_id) {
        @if (planOption.plan) {
          <div
            class="plan-card"
            [class.selected]="selectedPlan?.plan_id === planOption.plan.plan_id"
            (click)="selectPlan(planOption.plan)">
            <div class="plan-header">
              <div class="plan-name">{{ planOption.plan.name }}</div>
              <div class="plan-price">{{ formatPrice(planOption.plan.price_cents) }} {{ planOption.plan.currency || 'NOK' }}/{{ planOption.plan.billing_cycle }}</div>
            </div>

            @if (planOption.plan.description) {
              <p class="plan-description">{{ planOption.plan.description }}</p>
            }

            <div class="plan-discount">
              <span class="discount-price">{{ planOption.discounted_price }} {{ planOption.plan.currency || 'NOK' }}</span>
              <span class="discount-badge">{{ 'membershipPurchase.save' | translate }} {{ planOption.savings_percent }}%</span>
            </div>

            @if (planOption.plan.benefits && planOption.plan.benefits.length > 0) {
              <ul class="plan-benefits">
                @for (benefit of planOption.plan.benefits.slice(0, 3); track benefit) {
                  <li><i class="fas fa-check"></i> {{ benefit }}</li>
                }
              </ul>
            }

            <div class="plan-select-indicator">
              @if (selectedPlan?.plan_id === planOption.plan.plan_id) {
                <i class="fas fa-check-circle"></i> {{ 'membershipPurchase.selected' | translate }}
              } @else {
                <span class="text-muted">{{ 'membershipPurchase.clickToSelect' | translate }}</span>
              }
            </div>
          </div>
        }
      }
    </div>
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="close()">
    {{ 'membershipPurchase.maybeLater' | translate }}
  </button>
  <button
    type="button"
    class="btn btn-primary"
    (click)="purchase()"
    [disabled]="!selectedPlan || isPurchasing">
    @if (isPurchasing) {
      <span class="spinner-border spinner-border-sm me-1"></span>
      {{ 'membershipPurchase.processing' | translate }}
    } @else {
      {{ 'membershipPurchase.getMembership' | translate }}
    }
  </button>
</div>
